import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['fixedLeaseStatus', 'leaseStatus']

  checkFixedLeaseStatus() {
    this.fixedLeaseStatusTarget.checked = true
  }
}
